import { defineMessages } from 'react-intl';

import { pullRequestStatusMessages } from '../../../../../../../common/utils/pull-request-status';

const localMessages = defineMessages({
	resultLabel: {
		id: 'search-pull-request-result.label',
		defaultMessage: 'Pull request',
		description: 'Search pull request label',
	},
});

export const messages = {
	...localMessages,
	...pullRequestStatusMessages,
};
